<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "../../../components/table/datatable";
import {required, email} from 'vuelidate/lib/validators'
import userService from "../../../services/user.service";
import Vue from "vue";
import store from '@/state/store'

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Users",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Datatable, Layout, PageHeader},
  mounted() {
    this.fetchUsers()

  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    fetchUsers(url, params) {
      console.log(userService)
      return userService.get(url, true, params)
    },
    onLoadData(data) {
      this.users = data
    },
    changePassword(user) {
      this.currentUser = user
      this.showChangePasswordModal = true
      store.dispatch('notification/clear')
    },
    updatePassword() {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) return
      if (this.currentUser) {
        console.log(this.password)
        userService.changePassword(this.currentUser.id, this.password).then(res => {
          store.dispatch('toastState/success', "Password changed successfully")
          this.$refs.users.reload()
          this.currentUser = null
          this.showChangePasswordModal = false
        }).catch(error => {
          store.dispatch('notification/error', error)
        })
      }
    }

  },

  validations: {
    password: {required}
  },
  data() {
    return {
      columns: ['name', 'email', 'last_login', 'action'],
      users: [],
      password: null,
      currentUser: null,
      showModal: false,
      showSaveAsModal: false,
      title: "Users",
      submitted: false,
      showChangePasswordModal: false,
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Users",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <datatable :columns="columns" :request="fetchUsers" ref="users" :on-data-change="onLoadData">
      <tr v-for="user in users">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ (user.last_login ? (user.last_login.last_login) : "") | timeAgo }}</td>
        <td>
          <b-dropdown class="card-drop"
                      variant="white"
                      menu-class="dropdown-menu-end"
                      right
                      toggle-class="p-0">
            <template v-slot:button-content>
              <i class="mdi mdi-dots-horizontal font-size-18"></i>
            </template>
            <b-dropdown-item href="javascript: void(0);" @click="changePassword(user)">Change Password</b-dropdown-item>
          </b-dropdown>

        </td>
      </tr>
    </datatable>
    <b-modal v-model="showChangePasswordModal" title="Update Password" centered @ok.prevent="updatePassword">
      <div
          v-if="notification.message"
          :class="'alert ' + notification.type">
        {{ notification.message }}
      </div>
      <div class="row">
        <div class="col-12">

          <b-form-group label="New Password" class="form-group row mb-3">
            <b-form-input
                id="name"
                v-model.trim.lazy="password"
                type="text"
                @blur="$v.password.$touch"
                placeholder="Enter Name"

                :class="{ 'is-invalid': $v.password.$error }"></b-form-input>
            <div
                v-if="submitted && !$v.password.required"
                class="invalid-feedback">
              Password is required
            </div>
          </b-form-group>

        </div>
        <!-- end col -->
      </div>

    </b-modal>
  </Layout>
</template>